import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import { If } from 'app/components';
import { dialogService } from 'app/services/dialog.service';

import { selectDialogData } from './core.slice';

const titles = {
    confirm: 'Confirmation',
    error: 'Error',
};

export const ConfirmDialog: React.FunctionComponent = () => {
    const data = useSelector(selectDialogData);

    return (
        <Dialog
            open={data !== undefined}
            onClose={() => dialogService.dismiss()}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >
            <DialogTitle id='alert-dialog-title'>{titles[data?.type ?? 'confirm']}</DialogTitle>
            <DialogContent>
                <DialogContentText id='alert-dialog-description'>{data?.message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <If condition={'confirm' === data?.type}>
                    <Button onClick={() => dialogService.confirm()} color='primary' autoFocus>
                        {data?.confirmText ?? 'Yes'}
                    </Button>
                </If>
                <Button onClick={() => dialogService.dismiss()} color='primary'>
                    {data?.cancelText ?? 'Cancel'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
